import Vue from "vue"
import { mapActions, mapGetters } from "vuex"

import CURRENT_QUERY from "@/queries/Current.query.gql"
import CURRENT_USER_FAVOURITES_QUERY from "@/queries/CurrentUser/Favourites.query.gql"
import GUEST_FAVOURITE_LISTINGS_QUERY from "@/queries/GuestFavouriteListings.query.gql"
import REMOVE_FAVOURITE_MUTATION from "@/queries/CurrentUser/RemoveFavourite.mutation.gql"

const store = Vue.observable({
  favouritesCount: null,
  currentUser: {},
})

export const getters = {
  favouritesCount: {
    get: () => (store.favouritesCount > 99 ? 99 : store.favouritesCount),
    set: (value) => (store.favouritesCount = value),
  },
}

// This components handles resolving Guest and User in Favourites
export default {
  data: () => ({
    recentFavourites: [],
  }),
  render() {
    return this.$scopedSlots.default({
      currentUser: this.currentUser,
      favourites: this.recentFavourites,
      favouritesCount: this.favouritesCount,
      removeFavourite: this.removeFavourite,
      refetch: () => (this.currentUser ? this.$apollo.queries.userFavourites.refetch() : true),
    })
  },
  apollo: {
    currentUser: {
      query: CURRENT_QUERY,
    },
    userFavourites: {
      query: CURRENT_USER_FAVOURITES_QUERY,
      manual: true,
      result({ data }) {
        this.recentFavourites = data.currentUser.recentFavourites
        this.favouritesCount = data.currentUser.favouritesCount
      },
      skip() {
        return !this.currentUser
      },
    },
    guestFavourites: {
      query: GUEST_FAVOURITE_LISTINGS_QUERY,
      variables() {
        return {
          ids: this.favouriteIds,
        }
      },
      manual: true,
      result({ data }) {
        this.recentFavourites = data.guestFavouriteListings
        this.favouritesCount = this.favouriteIds.length
      },
      skip() {
        return this.currentUser
      },
    },
  },
  methods: {
    removeFavourite(listingId) {
      this.currentUser ? this.removeUserFavourite(listingId) : this.removeGuestFavourite(listingId)
    },
    removeUserFavourite(listingId) {
      this.$apollo.mutate({
        mutation: REMOVE_FAVOURITE_MUTATION,
        variables: { id: listingId },
        update: (store, { data: { removeFavourite } }) => {
          const query = CURRENT_USER_FAVOURITES_QUERY
          const data = store.readQuery({ query })

          data.currentUser = { ...data.currentUser, ...removeFavourite.user }
          store.writeQuery({ query, data })
        },
      })
    },
    removeGuestFavourite(listingId) {
      this.removeFavourite(listingId)
    },
    ...mapActions("guest", { removeGuestFavourite: "removeFavourite" }),
  },
  computed: {
    ...getters,
    ...mapGetters("guest", ["favouriteIds"]),
  },
  watch: {
    favouritesCount(value, previous) {
      previous != null &&
        this.$emit("favouritesCountChange", {
          value: value,
          previous: previous,
          currentUser: this.currentUser,
        })
    },
  },
}
